/**
 * P3.3.a · SPA helper · GET /api/sessions/:id/cost
 *
 * Server returns SUM 当前 session 全部 task_run 的 cost。
 * estimated: true 永远（v0.1 不维护精确价格表）。
 *
 * 真源协议：apps/backend/src/routes/sessions-chat.ts (P3.3.a endpoint)
 */

export interface SessionCost {
  session_id: string;
  run_count: number;
  total_tokens_in: number;
  total_tokens_out: number;
  /** USD * 1_000_000 · 0 表示 model 不支持估算或 task_run 未上报 cost */
  total_cost_usd_micros: number;
  /** v0.1 一律 true · 给 SPA 加 (~estimated) 角标 */
  estimated: true;
}

export async function fetchSessionCost(
  backendUrl: string,
  token: string,
  sessionId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<SessionCost> {
  const url = `${backendUrl.replace(/\/$/, '')}/api/sessions/${encodeURIComponent(sessionId)}/cost`;
  const resp = await fetchImpl(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) {
    throw new Error(`cost fetch failed: ${resp.status}`);
  }
  const body = await resp.json() as Partial<SessionCost>;
  // Defensive · server is trusted but field-check protects against deploy
  // skew where /cost gets returned by a stub or proxied to wrong route.
  if (
    typeof body.session_id !== 'string' ||
    typeof body.run_count !== 'number' ||
    typeof body.total_tokens_in !== 'number' ||
    typeof body.total_tokens_out !== 'number' ||
    typeof body.total_cost_usd_micros !== 'number'
  ) {
    throw new Error('cost fetch returned malformed body');
  }
  return {
    session_id: body.session_id,
    run_count: body.run_count,
    total_tokens_in: body.total_tokens_in,
    total_tokens_out: body.total_tokens_out,
    total_cost_usd_micros: body.total_cost_usd_micros,
    estimated: true,
  };
}
